import { CheckoutAfterLogin } from '../types/checkout-after-login';

export const getCheckoutAfterLoginObj = (encoded: string | null) => {
  if (!encoded) return undefined;
  return JSON.parse(atob(encoded)) as CheckoutAfterLogin;
};
